var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    (_vm.$userIsAdmin || _vm.$userIsIntern || _vm.$userIsManager) &&
    _vm.userIsTalent
      ? _c("h2", [_vm._v(_vm._s(_vm.user.first_name) + "'s Bookings")])
      : _vm.$userIsTalent
      ? _c("h2", [_vm._v("My Bookings")])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "panel panel-grey m-b-xl" }, [
      _c(
        "div",
        { staticClass: "panel-body" },
        [
          _c(
            "ul",
            { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
            [
              _vm.$vlastMode && _vm.$offersModuleEnabled
                ? _c(
                    "li",
                    { class: { active: _vm.status === "scheduled" } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              params: { status: "offer" },
                              query: _vm.$route.query,
                            },
                          },
                        },
                        [_vm._v("Offers")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { class: { active: _vm.status === "event" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { status: "event" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Booked Events")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: { active: _vm.status === "campaign" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { status: "campaign" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Booked Campaigns")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: { active: _vm.status === "completed-event" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { status: "completed-event" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Completed Events")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: { active: _vm.status === "completed-campaign" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { status: "completed-campaign" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Completed Campaigns")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: { active: _vm.status === "archived" } },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { status: "archived" },
                          query: _vm.$route.query,
                        },
                      },
                    },
                    [_vm._v("Cancelled")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.fetchingBookings
            ? _c("pickstar-loading", { staticClass: "m-t-lg" })
            : [
                _vm.haveNoBookings
                  ? _c("no-results", [
                      _c("div", [_vm._v("There are no bookings.")]),
                      _vm._v(" "),
                      _vm.haveAppliedFilters
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-default btn-sm m-t-sm",
                              on: { click: _vm.handleResetFiltersCallback },
                            },
                            [_vm._v("Reset Filters")]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "item-detail item-detail-price list-links" },
                  _vm._l(_vm.bookings, function (booking) {
                    return _c("profile-talent-booking-list-item", {
                      key: booking.id,
                      attrs: { booking: booking },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "lazy-loading",
                  {
                    ref: "lazyLoading",
                    staticClass: "text-center",
                    attrs: {
                      loading: _vm.loading,
                      "reached-bottom": _vm.handleGetNextTalentBookingsCallback,
                    },
                  },
                  [
                    _c("pickstar-loading", {
                      attrs: { slot: "loading" },
                      slot: "loading",
                    }),
                    _vm._v(" "),
                    _c("span", {
                      attrs: { slot: "finished" },
                      slot: "finished",
                    }),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }